// extracted by mini-css-extract-plugin
export default {"home":"SchoolifyContainer_home__CesrM"};